export default __webpack_public_path__ + "static/nextGenerationMechanicalBenchtopMobile-2ea2d022d204f0dde8c9bd67e261aa9d.png";